/**
 * Qué productos se preguntaban en el cierre de una fecha (migración 0323).
 *
 * El catálogo de una campaña cambia en el camino: el 23-oct fijas pasó a los 8 productos con los que se
 * mide el objetivo y Vital dejó Cero Cero. Regla del usuario: *«todos los cambios son desde este fin de
 * semana, lo anterior ya queda registrado como lo levantamos»*. Por eso lo que sale no se borra ni
 * desaparece del pasado: lleva `vigente_hasta`, y lo que entra lleva `vigente_desde`.
 *
 * - El celular pregunta lo que vale el día del turno.
 * - La bandeja muestra cada cierre con lo que se preguntó SU día: un cierre del 18-oct sigue enseñando
 *   los panes que se levantaron, y no se llena de ceros de productos que todavía no existían.
 *
 * Un producto sin fechas vale para cualquier día, que es como estaban todos antes de la 0323.
 */
export interface Vigencia {
  vigente_desde?: string | null;
  vigente_hasta?: string | null;
}

/** Los productos del catálogo vigentes en `fecha` (YYYY-MM-DD), en el mismo orden. Ambos extremos cuentan. */
export function skusVigentesEn<T extends Vigencia>(catalogo: T[], fecha: string): T[] {
  return catalogo.filter((s) => (!s.vigente_desde || fecha >= s.vigente_desde)
    && (!s.vigente_hasta || fecha <= s.vigente_hasta));
}
